__turbopack_export_value__({
  "section": "MainSlider-module-scss-module__xK0sra__section",
  "section__buttons": "MainSlider-module-scss-module__xK0sra__section__buttons",
  "section__nav": "MainSlider-module-scss-module__xK0sra__section__nav",
  "section__navInner": "MainSlider-module-scss-module__xK0sra__section__navInner",
  "section__slider": "MainSlider-module-scss-module__xK0sra__section__slider",
  "section__sliderDots": "MainSlider-module-scss-module__xK0sra__section__sliderDots",
  "slick-slide": "MainSlider-module-scss-module__xK0sra__slick-slide",
});
